import '../css/chart.css'
import { ReactComponent as ChartBSvg } from "../assets/chartBSvg"


export const ChartB = (props: any) => {

return  (
    <>
   
        
  
        <ChartBSvg
            className = {props.className}
            centerX='475' 
            centerY='475'  
            signRadius = '575'
            signBorderRadius = '576' 
            planetRadius = '500' 
            houseRadius = '205' 
            centerRadius = '110'
            DegreeSym = {props.DegreeSym}
            AriBSignX = {props.signBVals.AriBSignX}
            AriBSignY = {props.signBVals.AriBSignY}
            TauBSignX = {props.signBVals.TauBSignX}
            TauBSignY = {props.signBVals.TauBSignY}
            GemBSignX = {props.signBVals.GemBSignX}
            GemBSignY = {props.signBVals.GemBSignY}
            CanBSignX = {props.signBVals.CanBSignX}
            CanBSignY = {props.signBVals.CanBSignY}
            LeoBSignX = {props.signBVals.LeoBSignX}
            LeoBSignY = {props.signBVals.LeoBSignY}
            VirBSignX = {props.signBVals.VirBSignX}
            VirBSignY = {props.signBVals.VirBSignY}
            LibBSignX = {props.signBVals.LibBSignX}
            LibBSignY = {props.signBVals.LibBSignY}
            ScoBSignX = {props.signBVals.ScoBSignX}
            ScoBSignY = {props.signBVals.ScoBSignY}
            SagBSignX = {props.signBVals.SagBSignX}
            SagBSignY = {props.signBVals.SagBSignY}
            CapBSignX = {props.signBVals.CapBSignX}
            CapBSignY = {props.signBVals.CapBSignY}
            AquBSignX = {props.signBVals.AquBSignX}
            AquBSignY = {props.signBVals.AquBSignY}
            PisBSignX = {props.signBVals.PisBSignX}
            PisBSignY = {props.signBVals.PisBSignY}
            RXBSym = {props.raBVals.RXSym}
            MoBSym = {props.moBVals.MoBSym}
            MoBPlanetX = {props.moBVals.MoBPlanetX}
            MoBPlanetY = {props.moBVals.MoBPlanetY}
            MoBSign = {props.moBVals.MoBSign}
            MoBSignSym = {props.moBVals.MoBSignSym}
            MoBSignX = {props.moBVals.MoBSignX}
            MoBSignY = {props.moBVals.MoBSignY}
            MoBDegree = {props.moBVals.MoBDegree}
            MoBDegreeX = {props.moBVals.MoBDegreeX}
            MoBDegreeY = {props.moBVals.MoBDegreeY}
            MoBMinute = {props.moBVals.MoBMinute}
            MoBMinuteX = {props.moBVals.MoBMinuteX}
            MoBMinuteY = {props.moBVals.MoBMinuteY}
            VeBSym = {props.veBVals.VeBSym}
            VeBSign = {props.veBVals.VeBSign}
            VeBPlanetX = {props.veBVals.VeBPlanetX}
            VeBPlanetY = {props.veBVals.VeBPlanetY}
            VeBSignSym = {props.veBVals.VeBSignSym}
            VeBSignX = {props.veBVals.VeBSignX}
            VeBSignY = {props.veBVals.VeBSignY}
            VeBDegree = {props.veBVals.VeBDegree}
            VeBDegreeX = {props.veBVals.VeBDegreeX}
            VeBDegreeY = {props.veBVals.VeBDegreeY}
            VeBMinute = {props.veBVals.VeBMinute}
            VeBMinuteX = {props.veBVals.VeBMinuteX}
            VeBMinuteY = {props.veBVals.VeBMinuteY}
            VeBRX = {props.veBVals.VeBRX}
            VeBRXX = {props.veBVals.VeBRXX}
            VeBRXY = {props.veBVals.VeBRXY}
            ASCBSym = {props.ascBVals.ASCBSym}
            ASCBPlanetX = {props.ascBVals.ASCBPlanetX}
            ASCBPlanetY = {props.ascBVals.ASCBPlanetY}
            ASCBSign = {props.ascBVals.ASCBSign}
            ASCBSignSym = {props.ascBVals.ASCBSignSym}
            ASCBSignX = {props.ascBVals.ASCBSignX}
            ASCBSignY = {props.ascBVals.ASCBSignY}
            ASCBDegree = {props.ascBVals.ASCBDegree}
            ASCBDegreeX = {props.ascBVals.ASCBDegreeX}
            ASCBDegreeY = {props.ascBVals.ASCBDegreeY}
            ASCBMinute = {props.ascBVals.ASCBMinute}
            ASCBMinuteX = {props.ascBVals.ASCBMinuteX}
            ASCBMinuteY = {props.ascBVals.ASCBMinuteY}
            RaBSym = {props.raBVals.RaBSym}
            RaBPlanetX = {props.raBVals.RaBPlanetX}
            RaBPlanetY = {props.raBVals.RaBPlanetY}
            RaBSign = {props.raBVals.RaBSign}
            RaBSignSym = {props.raBVals.RaBSignSym}
            RaBSignX = {props.raBVals.RaBSignX}
            RaBSignY = {props.raBVals.RaBSignY}
            RaBDegree = {props.raBVals.RaBDegree}
            RaBDegreeX = {props.raBVals.RaBDegreeX}
            RaBDegreeY = {props.raBVals.RaBDegreeY}
            RaBMinute = {props.raBVals.RaBMinute}
            RaBMinuteX = {props.raBVals.RaBMinuteX}
            RaBMinuteY = {props.raBVals.RaBMinuteY}
            RaBRX = {props.raBVals.RaBRX}
            RaBRXX = {props.raBVals.RaBRXX}
            RaBRXY = {props.raBVals.RaBRXY}
            SuBSym = {props.suBVals.SuBSym}
            SuBPlanetX = {props.suBVals.SuBPlanetX}
            SuBPlanetY = {props.suBVals.SuBPlanetY}
            SuBSign = {props.suBVals.SuBSign}
            SuBSignSym = {props.suBVals.SuBSignSym}
            SuBSignX = {props.suBVals.SuBSignX}
            SuBSignY = {props.suBVals.SuBSignY}
            SuBDegree = {props.suBVals.SuBDegree}
            SuBDegreeX = {props.suBVals.SuBDegreeX}
            SuBDegreeY = {props.suBVals.SuBDegreeY}
            SuBMinute = {props.suBVals.SuBMinute}
            SuBMinuteX = {props.suBVals.SuBMinuteX}
            SuBMinuteY = {props.suBVals.SuBMinuteY}
            ChBPlanetX = {props.chBVals.ChBPlanetX}
            ChBPlanetY = {props.chBVals.ChBPlanetY}
            ChBSym = {props.chBVals.ChBSym}
            ChBSign = {props.chBVals.ChBSign}
            ChBSignSym = {props.chBVals.ChBSignSym}
            ChBSignX = {props.chBVals.ChBSignX}
            ChBSignY = {props.chBVals.ChBSignY}
            ChBDegree = {props.chBVals.ChBDegree}
            ChBDegreeX = {props.chBVals.ChBDegreeX}
            ChBDegreeY = {props.chBVals.ChBDegreeY}
            ChBMinute = {props.chBVals.ChBMinute}
            ChBMinuteX = {props.chBVals.ChBMinuteX}
            ChBMinuteY = {props.chBVals.ChBMinuteY}
            ChBRX = {props.chBVals.ChBRX}
            ChBRXX = {props.chBVals.ChBRXX}
            ChBRXY = {props.chBVals.ChBRXY}
            MeBSym = {props.meBVals.MeBSym}
            MeBPlanetX = {props.meBVals.MeBPlanetX}
            MeBPlanetY = {props.meBVals.MeBPlanetY}
            MeBSign = {props.meBVals.MeBSign}
            MeBSignSym = {props.meBVals.MeBSignSym}
            MeBSignX = {props.meBVals.MeBSignX}
            MeBSignY = {props.meBVals.MeBSignY}
            MeBDegree = {props.meBVals.MeBDegree}
            MeBDegreeX = {props.meBVals.MeBDegreeX}
            MeBDegreeY = {props.meBVals.MeBDegreeY}
            MeBMinute = {props.meBVals.MeBMinute}
            MeBMinuteX = {props.meBVals.MeBMinuteX}
            MeBMinuteY = {props.meBVals.MeBMinuteY}
            MeBRX = {props.meBVals.MeBRX}
            MeBRXX = {props.meBVals.MeBRXX}
            MeBRXY = {props.meBVals.MeBRXY}
            JuBSym = {props.juBVals.JuBSym}
            JuBPlanetX = {props.juBVals.JuBPlanetX}
            JuBPlanetY = {props.juBVals.JuBPlanetY}
            JuBSign = {props.juBVals.JuBSign}
            JuBSignSym = {props.juBVals.JuBSignSym}
            JuBSignX = {props.juBVals.JuBSignX}
            JuBSignY = {props.juBVals.JuBSignY}
            JuBDegree = {props.juBVals.JuBDegree}
            JuBDegreeX = {props.juBVals.JuBDegreeX}
            JuBDegreeY = {props.juBVals.JuBDegreeY}
            JuBMinute = {props.juBVals.JuBMinute}
            JuBMinuteX = {props.juBVals.JuBMinuteX}
            JuBMinuteY = {props.juBVals.JuBMinuteY}
            JuBRX = {props.juBVals.JuBRX}
            JuBRXX = {props.juBVals.JuBRXX}
            JuBRXY = {props.juBVals.JuBRXY}
            UrBSym = {props.urBVals.UrBSym}
            UrBPlanetX = {props.urBVals.UrBPlanetX}
            UrBPlanetY = {props.urBVals.UrBPlanetY}
            UrBSign = {props.urBVals.UrBSign}
            UrBSignSym = {props.urBVals.UrBSignSym}
            UrBSignX = {props.urBVals.UrBSignX}
            UrBSignY = {props.urBVals.UrBSignY}
            UrBDegree = {props.urBVals.UrBDegree}
            UrBDegreeX = {props.urBVals.UrBDegreeX}
            UrBDegreeY = {props.urBVals.UrBDegreeY}
            UrBMinute = {props.urBVals.UrBMinute}
            UrBMinuteX = {props.urBVals.UrBMinuteX}
            UrBMinuteY = {props.urBVals.UrBMinuteY}
            UrBRX = {props.urBVals.UrBRX}
            UrBRXX = {props.urBVals.UrBRXX}
            UrBRXY = {props.urBVals.UrBRXY}
            ICBSym = {props.icBVals.ICBSym}
            ICBPlanetX = {props.icBVals.ICBPlanetX}
            ICBPlanetY = {props.icBVals.ICBPlanetY}
            ICBSign = {props.icBVals.ICBSign}
            ICBSignSym = {props.icBVals.ICBSignSym}
            ICBSignX = {props.icBVals.ICBSignX}
            ICBSignY = {props.icBVals.ICBSignY}
            ICBDegree = {props.icBVals.ICBDegree}
            ICBDegreeX = {props.icBVals.ICBDegreeX}
            ICBDegreeY = {props.icBVals.ICBDegreeY}
            ICBMinute = {props.icBVals.ICBMinute}
            ICBMinuteX = {props.icBVals.ICBMinuteX}
            ICBMinuteY = {props.icBVals.ICBMinuteY}
            MCBSym = {props.mcBVals.MCBSym}
            MCBPlanetX = {props.mcBVals.MCBPlanetX}
            MCBPlanetY = {props.mcBVals.MCBPlanetY}
            MCBSign = {props.mcBVals.MCBSign}
            MCBSignSym = {props.mcBVals.MCBSignSym}
            MCBSignX = {props.mcBVals.MCBSignX}
            MCBSignY = {props.mcBVals.MCBSignY}
            MCBDegree = {props.mcBVals.MCBDegree}
            MCBDegreeX = {props.mcBVals.MCBDegreeX}
            MCBDegreeY = {props.mcBVals.MCBDegreeY}
            MCBMinute = {props.mcBVals.MCBMinute}
            MCBMinuteX = {props.mcBVals.MCBMinuteX}
            MCBMinuteY = {props.mcBVals.MCBMinuteY}
            DSCBSym = {props.dscBVals.DSCBSym}
            DSCBPlanetX = {props.dscBVals.DSCBPlanetX}
            DSCBPlanetY = {props.dscBVals.DSCBPlanetY}
            DSCBSign = {props.dscBVals.DSCBSign}
            DSCBSignSym = {props.dscBVals.DSCBSignSym}
            DSCBSignX = {props.dscBVals.DSCBSignX}
            DSCBSignY = {props.dscBVals.DSCBSignY}
            DSCBDegree = {props.dscBVals.DSCBDegree}
            DSCBDegreeX = {props.dscBVals.DSCBDegreeX}
            DSCBDegreeY = {props.dscBVals.DSCBDegreeY}
            DSCBMinute = {props.dscBVals.DSCBMinute}
            DSCBMinuteX = {props.dscBVals.DSCBMinuteX}
            DSCBMinuteY = {props.dscBVals.DSCBMinuteY}
            KeBSym = {props.keBVals.KeBSym}
            KeBPlanetX = {props.keBVals.KeBPlanetX}
            KeBPlanetY = {props.keBVals.KeBPlanetY}
            KeBSign = {props.keBVals.KeBSign}
            KeBSignSym = {props.keBVals.KeBSignSym}
            KeBSignX = {props.keBVals.KeBSignX}
            KeBSignY = {props.keBVals.KeBSignY}
            KeBDegree = {props.keBVals.KeBDegree}
            KeBDegreeX = {props.keBVals.KeBDegreeX}
            KeBDegreeY = {props.keBVals.KeBDegreeY}
            KeBMinute = {props.keBVals.KeBMinute}
            KeBMinuteX = {props.keBVals.KeBMinuteX}
            KeBMinuteY = {props.keBVals.KeBMinuteY}
            KeBRX = {props.keBVals.KeBRX}
            KeBRXX = {props.keBVals.KeBRXX}
            KeBRXY = {props.keBVals.KeBRXY}
            PlBSym = {props.plBVals.PlBSym}
            PlBPlanetX = {props.plBVals.PlBPlanetX}
            PlBPlanetY = {props.plBVals.PlBPlanetY}
            PlBSign = {props.plBVals.PlBSign}
            PlBSignSym = {props.plBVals.PlBSignSym}
            PlBSignX = {props.plBVals.PlBSignX}
            PlBSignY = {props.plBVals.PlBSignY}
            PlBDegree = {props.plBVals.PlBDegree}
            PlBDegreeX = {props.plBVals.PlBDegreeX}
            PlBDegreeY = {props.plBVals.PlBDegreeY}
            PlBMinute = {props.plBVals.PlBMinute}
            PlBMinuteX = {props.plBVals.PlBMinuteX}
            PlBMinuteY = {props.plBVals.PlBMinuteY}
            PlBRX = {props.plBVals.PlBRX}
            PlBRXX = {props.plBVals.PlBRXX}
            PlBRXY = {props.plBVals.PlBRXY}
            MaBSym = {props.maBVals.MaBSym}
            MaBPlanetX = {props.maBVals.MaBPlanetX}
            MaBPlanetY = {props.maBVals.MaBPlanetY}
            MaBSign = {props.maBVals.MaBSign}
            MaBSignSym = {props.maBVals.MaBSignSym}
            MaBSignX = {props.maBVals.MaBSignX}
            MaBSignY = {props.maBVals.MaBSignY}
            MaBDegree = {props.maBVals.MaBDegree}
            MaBDegreeX = {props.maBVals.MaBDegreeX}
            MaBDegreeY = {props.maBVals.MaBDegreeY}
            MaBMinute = {props.maBVals.MaBMinute}
            MaBMinuteX = {props.maBVals.MaBMinuteX}
            MaBMinuteY = {props.maBVals.MaBMinuteY}
            MaBRX = {props.maBVals.MaBRX}
            MaBRXX = {props.maBVals.MaBRXX}
            MaBRXY = {props.maBVals.MaBRXY}
            SaBSym = {props.saBVals.SaBSym}
            SaBPlanetX = {props.saBVals.SaBPlanetX}
            SaBPlanetY = {props.saBVals.SaBPlanetY}
            SaBSign = {props.saBVals.SaBSign}
            SaBSignSym = {props.saBVals.SaBSignSym}
            SaBSignX = {props.saBVals.SaBSignX}
            SaBSignY = {props.saBVals.SaBSignY}
            SaBDegree = {props.saBVals.SaBDegree}
            SaBDegreeX = {props.saBVals.SaBDegreeX}
            SaBDegreeY = {props.saBVals.SaBDegreeY}
            SaBMinute = {props.saBVals.SaBMinute}
            SaBMinuteX = {props.saBVals.SaBMinuteX}
            SaBMinuteY = {props.saBVals.SaBMinuteY}
            SaBRX = {props.saBVals.SaBRX}
            SaBRXX = {props.saBVals.SaBRXX}
            SaBRXY = {props.saBVals.SaBRXY}
            NeBSym = {props.neBVals.NeBSym}
            NeBPlanetX = {props.neBVals.NeBPlanetX}
            NeBPlanetY = {props.neBVals.NeBPlanetY}
            NeBSign = {props.neBVals.NeBSign}
            NeBSignSym = {props.neBVals.NeBSignSym}
            NeBSignX = {props.neBVals.NeBSignX}
            NeBSignY = {props.neBVals.NeBSignY}
            NeBDegree = {props.neBVals.NeBDegree}
            NeBDegreeX = {props.neBVals.NeBDegreeX}
            NeBDegreeY = {props.neBVals.NeBDegreeY}
            NeBMinute = {props.neBVals.NeBMinute}
            NeBMinuteX = {props.neBVals.NeBMinuteX}
            NeBMinuteY = {props.neBVals.NeBMinuteY}
            NeBRX = {props.neBVals.NeBRX}
            NeBRXX = {props.neBVals.NeBRXX}
            NeBRXY = {props.neBVals.NeBRXY}
            LoFoBSym = {props.lofoBVals.LoFoBSym}
            LoFoBPlanetX = {props.lofoBVals.LoFoBPlanetX}
            LoFoBPlanetY = {props.lofoBVals.LoFoBPlanetY}
            LoFoBSign = {props.lofoBVals.LoFoBSign}
            LoFoBSignSym = {props.lofoBVals.LoFoBSignSym}
            LoFoBSignX = {props.lofoBVals.LoFoBSignX}
            LoFoBSignY = {props.lofoBVals.LoFoBSignY}
            LoFoBDegree = {props.lofoBVals.LoFoBDegree}
            LoFoBDegreeX = {props.lofoBVals.LoFoBDegreeX}
            LoFoBDegreeY = {props.lofoBVals.LoFoBDegreeY}
            LoFoBMinute = {props.lofoBVals.LoFoBMinute}
            LoFoBMinuteX = {props.lofoBVals.LoFoBMinuteX}
            LoFoBMinuteY = {props.lofoBVals.LoFoBMinuteY}
  />
    
    </>
        
    )  
    
}


